"use client"; // src/utils/array.ts

import _createForOfIteratorHelper from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _toConsumableArray from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";

function toArray(arg) {
  if (Array.isArray(arg)) {
    return arg;
  }

  return typeof arg !== "undefined" ? [arg] : [];
}

function addItemToArray(array, item) {
  var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;

  if (!(index in array)) {
    return [].concat(_toConsumableArray(array), [item]);
  }

  return [].concat(_toConsumableArray(array.slice(0, index)), [item], _toConsumableArray(array.slice(index)));
}

function flatten2DArray(array) {
  var flattened = [];

  var _iterator = _createForOfIteratorHelper(array),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var row = _step.value;
      flattened.push.apply(flattened, _toConsumableArray(row));
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return flattened;
}

function reverseArray(array) {
  return array.slice().reverse();
}

export { toArray, addItemToArray, flatten2DArray, reverseArray };